export default {
    url: '/formcategories',
    template: '<ui-view></ui-view>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/settings/formcategories/index.js